import { PricingTable } from "@components/pricing/PricingTable";
import { FAQSection, Question } from "components/FAQSection";
import { CTASection } from "components/platform/CTASection";
import Layout from "components/platform/Layout";
import PricingFeatures from "components/pricing/PricingFeatures";
import PricingHero from "components/pricing/PricingHero";
import PricingTiers from "components/pricing/PricingTiers";
import { ReactElement } from "react";
import {
  HUMANLOOP_API_DOCS_LINK,
  HUMANLOOP_DOCS_LINK,
  SLACK_LINK,
} from "utils/constants";

const Pricing: NextPageTypes.NextPageWithLayout = () => (
  <main className="mt-32">
    <PricingHero />
    <PricingFeatures />
    <PricingTiers />
    <PricingTable />
    <FAQSection questions={questions} />
    <CTASection className="bg-gray-100" />
  </main>
);

Pricing.getLayout = function getLayout(page: ReactElement) {
  return <Layout title="Humanloop – Pricing">{page}</Layout>;
};

export default Pricing;

const questions: Question[] = [
  {
    question: "What is Humanloop?",
    answer:
      "Humanloop is a suite of tools for data scientists and engineers to collaborate with subject-matter experts to rapidly build and continuously improve NLP models.",
    defaultOpen: true,
  },
  {
    question: "What types of ML tasks are supported?",
    answer:
      "Text classification (including multi-label classification) and text extraction tasks are supported across annotation, model training and deployment. Text generation is coming soon!",
  },
  {
    question: "What are characters?",
    answer:
      "Prices are per 1,000 characters. A character is each letter or unicode character in the text. This paragraph is 127 characters.",
    defaultOpen: true,
  },
  {
    question: "How are AI-powered tools priced?",
    answer:
      "Model assisted tools are charged per 1k characters that are put through the model. For inference this is the size of the input text. For features",
    defaultOpen: true,
  },
  {
    question: "Is my data secure?",
    answer:
      "Your data is encrypted, private to your account and never shared with third parties. Our platform is regularly penetration tested to ensure we meet the best security standards. Our enterprise plans offer additional dedicated cloud deployment options.",
  },
  {
    question: "Can I export my data?",
    answer:
      "Yes, you can export all your data at any time in a variety of formats suitable for your machine learning pipeline.",
  },
  // {
  //   question: "Who owns the data? ",
  //   answer: "..."
  // },
  {
    question: "What data formats are supported?",
    answer: (
      <>
        JSON and CSV formats are supported for uploading data via the user
        interface or the API. See{" "}
        <a href={HUMANLOOP_DOCS_LINK}>our documentation</a> for further details.
      </>
    ),
  },
  {
    question: "Can I use my own model?",
    answer: (
      <>
        Our APIs and SDK allow you to use our tools with your own model where
        relevant. See <a href={HUMANLOOP_API_DOCS_LINK}>our documentation</a>{" "}
        for more details. For example, you can accelerate annotation efforts
        with active learning that leverages your model predictions.
      </>
    ),
  },
  {
    question: "What languages are supported?",
    answer:
      "This just depends on what model you are using. By default, Humanloop provides English models. We can also configure your projects to use models specific to any Romance language. Alternatively you can use your own model.",
  },
  {
    question: "How can I get support?",
    answer: (
      <>
        Join our <a href={SLACK_LINK}>community Slack server</a> or send us an
        email at <a href="mailto:team@humanloop.com">team@humanloop.com</a>.
      </>
    ),
  },
];
